import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServiceSelection from './components/ServiceSelection';
import ServiceDetails from './components/ServiceDetails';
import MultidisciplinaryServices from './components/MultidisciplinaryServices';
import AboutSection from './components/AboutSection';
import NewsEventsSection from './components/NewsEventsSection';
import PatientIntakeForm from './components/PatientIntakeForm';
import BookingSystem from './components/BookingSystem';
import FAQSection from './components/FAQSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ServiceSelection />
      <ServiceDetails />
      <MultidisciplinaryServices />
      <AboutSection />
      <NewsEventsSection />
      <PatientIntakeForm />
      <BookingSystem />
      <TestimonialsSection />
      <FAQSection />
      <ContactSection />
      <Footer />

      {/* Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/584143363083"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer"
        style={{ backgroundColor: '#25D366' }}
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl flex items-center justify-center w-8 h-8"></i>
      </a>
    </div>
  );
}
